import React from 'react'
import BidPlanResult, { BidPlanGroup, BidPlanItem } from "../code/models/BidPlanResult";
import '../css/customerinfobiddingplans.css';

const excludeIcon = require('../images/unavailable-red-64.png');
const combiIcon = require('../images/radio-toggle-purple.png');

interface ICustomerInfoBidPlan {
    bidPlanResult: BidPlanResult;
}

export default function CustomerInfoBidPlan({ bidPlanResult }: ICustomerInfoBidPlan) {
    //const [bidPlanGroups, setBidPlanGroups] = React.useState<BidPlanGroup[] | null>(null);
    React.useEffect(() => {

    }, []);

    function buildCategory(isReserve: boolean, isDeleted: boolean, category: string) {
        var val: string;
        switch (category) {
            case "waive":  // black
                val = "WAIVE";
                break;
            case "set":
                val = "SET";
                break; // blue
            case "preferoff":  // ??????
                //val = isReserve ? "REQUIRE": "PUT";
                val = "??????";
                break;
            case "avoid": // PUT RED
                val = isReserve ? "REQUIRED" : "BAN";
                break;
            case "avoid-down": // GREEN or ORANGE
                val = isReserve ? "DESIRED" : "DOWNGRADE";
                category = isReserve ? "desired" : category;
                break;
            case "award": // GREEN
                val = "PUT";
                break;
            case "lock":  // GREEN
                val = "LOCK";
                break;
            default:
                val = "?????";
                break;
        }

        if (isDeleted) category = "";
        return (
            <span className={category}>{val}</span>
        )
    }

    function buildCombiSpan() {
        return (
            <span className="bidplan-group-line-combi">COMBI BID</span>
        )
    }
    function buildDetail(groupNumber: number, isDeleted: boolean, line: BidPlanItem) {
        let downgrade = (typeof line.downgradeLevel === 'number') ? `(${line.downgradeLevel}) ` : "";
        return (line.extendedDetailLines || []).map((detLine, idx) => {
            let className = "bidplan-group-line-detail";
            let isCombi = false;

            if (!isDeleted && detLine.startsWith("EXCLUDE")) {
                className += " exclude";
            } else if (!isDeleted && detLine.startsWith("COMBI")) {
                isCombi = true;
            }
            return (
                <div className={className} key={`planln-dt-${groupNumber}-${line.lineNumber}-${idx}`}
                >{idx === 0 ? downgrade : ""}{detLine}{isCombi && buildCombiSpan()}</div>
            );
        });
    }

    function buildChangeType(line: BidPlanItem) {
        let ct = "";
        switch (line.changeType) {
            case "deleted":
                ct = "removed";
                break;
            case "added":
            case "changed":
                ct = line.changeType;
                break;
            default: ct = " ";
        }
        return (
            <span className={"bidplan-group-line-change " + ct}>{ct}</span>
        );
    }

    function buildGroupLine(isReserve: boolean, groupNumber: number, line: BidPlanItem) {
        let isDeleted = line.changeType === "deleted";
        return (
            <div className={isDeleted ? "row bidplan-group-line deleted" : "row bidplan-group-line"}
                key={`planln-${groupNumber}-${line.lineNumber}-${line.changeType}`}>
                <div className="col linenumber">{line.lineNumber + 1}</div>
                <div className="col category">{buildCategory(isReserve, isDeleted, line.category || "")}</div>
                <div className="col detail">{buildDetail(groupNumber, isDeleted, line)}</div>
                <div className="col lineweight">{line.lineWeight}</div>
                <div className="col changetype">{buildChangeType(line)}</div>
            </div>
        )
    }

    function buildGroup(group: BidPlanGroup) {
        let className = "row bidplan-group-header";
        if (group.lineCount > 50) {
            className += " too-many-rows";
        }
        return (
            <div className="row" key={`bpl-bg-${group.groupNumber}-${group.lineCount}-${group.isReserve}`}>
                <div className="col">
                    <div className={className}>{`Bid Group ${group.groupNumber + 1} (${group.isReserve ? "RESERVE" : "LINE"}) (${group.lineCount} Rows)`}</div>
                    {group.bidItems.map((bpl) => buildGroupLine(group.isReserve, group.groupNumber, bpl))}
                </div>
            </div>
        )
    }

    return (
        <React.Fragment key={`planresult-${bidPlanResult.bidPlanId}`}>
            <div className="bidplan-title">Bidding Plan for "{bidPlanResult.planName}" ({bidPlanResult.groups.length} Groups)</div>
            <div className="container row bidplan-container">
                {bidPlanResult.groups.map((grp) => buildGroup(grp))}
            </div>
        </React.Fragment>
    )
}
